import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { verificationJson } from '../utils/verificationJson';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { updateNonScheduleVerification } from '../../../../redux/features/crdMigrationSlice';
import { useSelector } from 'react-redux';
export default function AttendanceDetailsVerification({ row, setOpenModal, setRefresh }) {
  const [verification, setVerifiication] = useState({ id: '', value: '' });
  const [remarks, setRemarks] = useState('');
  const submitLoading = useSelector((state) => state.crdMigration.submitLoading);

  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();

  const submitHandler = () => {
    if (!verification?.id) return;
    const data = {
      attendanceVerificationID: row?.attendanceVerificationID,
      attendanceVerificationStatus: verification?.id,
      attendanceVerificationRemarks: remarks,
      batchID: row?.course_batch_id,
    };
    dispatch(updateNonScheduleVerification(data)).then((res) => {
      apiHelper(res, {
        onSuccess: () => {
          setVerifiication({ id: '', value: '' });
          setRemarks('');
          setOpenModal(false);
          setRefresh((prev) => !prev);
        },
      });
    });
  };
  return (
    <Stack gap={2}>
      <GlobalSelectFieldWithoutFormikNew
        data={verificationJson}
        fullWidth={true}
        keys={{
          itemId: 'id',
          itemValue: 'label',
        }}
        label={'Verification Status'}
        selectedDetails={verification}
        setChange={setVerifiication}
      />
      <TextField multiline label="Remarks" rows={3} onChange={(e) => setRemarks(e.target.value)} value={remarks} />
      <Button
        variant="outlined"
        sx={{
          alignSelf: 'flex-end',
        }}
        onClick={submitHandler}
        disabled={submitLoading}
      >
        {submitLoading ? 'Submitting...' : 'Submit'}
      </Button>
    </Stack>
  );
}
